export enum WhitelistView {
	START_PAGE,
	MATERIAL_TYPE,
	OVERVIEW,
	FINISHED
}
